// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__101a3","title":"Info_title__3FxRf","links":"Info_links__3V4U1","link":"Info_link__1Cm6Z","logo":"Info_logo__3IP5d"};